<template>
    <div :class="['contenedor-adjuntos', { pending: !puedeDescargar }]" v-if="fichero != null">
        <span class="file-name">{{ model.fileName }}</span>
        <div :class="['file-actions', { pending: !puedeDescargar }]">
            <span v-if="!puedeDescargar" class="pendiente"><i class="fa fa-info-circle"></i>
                {{ textForNonDownloadableFiles == null ? '' : textForNonDownloadableFiles }}
            </span>
            <div>
                <DxButton text="Reemplazar" @click="onReemplazarClicked" icon="fa fa-arrows-retweet"></DxButton>
                <DxButton @click="onFileRemoved" icon="fa fa-trash" text="Eliminar"></DxButton>
                <DxButton text="Descargar" @click="onFileDownloadRequested" :visible="puedeDescargar"
                    icon="fa fa-download">
                </DxButton>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { DxButton } from 'devextreme-vue';
import { computed, ref } from 'vue';

const props = defineProps<{
    fichero: Fichero
    supportedExtensions?: string[],
    textForAddAttachmentLabel: string,
    textForAddAttachmentButton: string,
    textForNonDownloadableFiles: string
}>();
const model = computed(() => props.fichero);
const textForNonDownloadableFiles = computed(() => props.textForNonDownloadableFiles);

const emit = defineEmits<{
    (ev: 'update:fichero', file: Fichero): void,
    (ev: 'fileReplaceRequested'): void,
    (ev: 'fileRemoveRequested'): void,
    (ev: 'fileDownloadRequested'): void
}>();


const puedeDescargar = computed(() => model.value != null && model.value.isRemote === true);

function onFileRemoved(): void {
    emit("fileRemoveRequested");
}


function onReemplazarClicked(): void {
    emit("fileReplaceRequested");
}


function onFileDownloadRequested() {
    emit("fileDownloadRequested");
}
</script>
<style scoped lang="scss">
@import "@/styles/_vars.scss";
@import "@/styles/figma.scss";
@import "@/styles/_themevars.scss";

.contenedor-adjuntos {
    display: flex;
    flex-direction: column;
    padding: var(--spacing-sm);
    justify-content: space-between;
    margin: var(--spacing-sm) 0;
    border-radius: var(--border-radius-lg);
    box-shadow: 0px 4px 4px 0px rgba(36, 36, 36, 0.10);

    border: 1px solid var(--border-default-default);

    &.pending {
        border-style: dashed;
        background-color: $datagrid-row-alternation-bg;
    }
}

.file-name {
    margin-right: var(--spacing-sm);
}

.file-actions {
    display: flex;
    justify-content: end;
    align-items: center;

    .pendiente {
        font-size: 0.875em;
        font-style: italic;
        display: flex;
        gap: var(--spacing-2xs);
    }

    div {
        display: flex;
        gap: var(--spacing-xs);
    }

    &.pending {
        justify-content: space-between;
    }
}
</style>